import type { DailyWorkFile } from '~/entities/dailyWorkFile'
import {
  deleteDailyWorkFile,
  getDailyWorkFileById,
} from '~/repositories/dailyWorkFileRepository'
import { DataNotFoundError } from '~/repositories/error'
import { updateWorkItemSchedules } from '~/repositories/workItemScheduleRepository'

// 「未着手に戻す」の処理
export const revertDailyWorkFile = async (dailyWorkFileId: DailyWorkFile['id']): Promise<void> => {
  const dailyWorkFile = await getDailyWorkFileById(dailyWorkFileId)

  if (!dailyWorkFile) {
    throw new DataNotFoundError()
  }

  const workItems = dailyWorkFile.work_sheets.flatMap((workSheet) => workSheet.work_items)
  const workItemScheduleIds = workItems
    .map((w) => w.work_item_schedule_id)
    .filter((id) => id !== null)

  if (workItemScheduleIds.length > 0) {
    await updateWorkItemSchedules(workItemScheduleIds, { isStarted: false, workStartedAt: null })
  }

  await deleteDailyWorkFile({
    workFileId: dailyWorkFile.id,
    locationId: dailyWorkFile.location_id,
  })
}
